import React from 'react';
import PropTypes from 'prop-types';

export const ColumnsTitle = ({ title }) => <span className="p-column-title">{title}</span>;

ColumnsTitle.propTypes = {
  title: PropTypes.string,
};
